import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons/index';
import { jobWorkerStatuses } from '../../../../constants/jobs';
import defaultUserPhoto from '../../../../images/default_user.png';

export default class TipWorker extends Component {
  static propTypes = {
    worker: PropTypes.object.isRequired,
    isSelected: PropTypes.bool.isRequired,
    handleWorkerSelection: PropTypes.func.isRequired
  };

  render () {
    const { worker, handleWorkerSelection, isSelected } = this.props;
    const { photo_image_url, status, actual_hours } = worker;
    const first_name = worker.first_name || '';
    const last_name = worker.last_name || '';
    const fullName = first_name + ' ' + last_name;
    return (
      <div className='worker-wrapper tip-rate-worker-wrapper'>
        <div className='photo-wrapper'>
          <div
            className='worker-photo'
            style={{ backgroundImage: `url('${photo_image_url || defaultUserPhoto}')` }}
          />
          <div className={`status-label ${status}`}>
            { jobWorkerStatuses.find(status => status.id === worker.status).value }
          </div>
        </div>
        <div className='worker-info'>
          <h4> {fullName} </h4>
          { !!actual_hours && (
            <p className='worker-info-row'>
              Hours Logged: <strong>{actual_hours} Hours</strong>
            </p>
          )}
        </div>
        <button
          className={`select-worker-checkbox ${isSelected ? 'active' : ''}`}
          onClick={() => handleWorkerSelection(worker)}
        >
          { isSelected && <FontAwesomeIcon icon={faCheck} />}
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/TipsAndRates/WorkerListItem.js